import React from "react";
import { Routes, Route } from "react-router-dom";
import ListLogsAndAudit from "../Components/Logs and Audit/listLogsAndAudit";

const LogsRoutes = () => {
  return (
    <Routes>
      <Route
        path="/logs_&_audit_trails"
        element={<ListLogsAndAudit></ListLogsAndAudit>}
      ></Route>
    </Routes>
  );
};

export default LogsRoutes;
